import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiArrowRight } = FiIcons;

const ProblemSection = () => {
  const problems = [
    "No importa cuánto te esfuerzas, siempre vuelves a los mismos hábitos y patrones.",
    "Sientes culpa después de comer o no puedes parar de comer ciertos alimentos.",
    "Sabes lo que tienes que hacer, pero algo dentro de ti no te deja avanzar.",
    "Te sientes estancado en tu progreso personal o físico."
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8">
            ¿Te Identificas con Esto?
          </h2>
          
          <div className="space-y-4 mb-8">
            {problems.map((problem, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex items-start gap-3 text-left bg-white p-4 rounded-lg shadow-sm"
              >
                <SafeIcon icon={FiCheck} className="text-red-500 text-xl mt-1 flex-shrink-0" />
                <p className="text-gray-700">{problem}</p>
              </motion.div>
            ))}
          </div>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-blue-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-blue-700 transition-colors flex items-center gap-2 mx-auto shadow-lg"
          >
            ¡Descubre cómo podemos ayudarte!
            <SafeIcon icon={FiArrowRight} className="text-xl" />
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default ProblemSection;